import React from 'react';
import { Helmet } from 'react-helmet-async';

import { PortalSelfExclusion } from 'playup-web-core';

import UsSelfExclusion from './UsSelfExclusion/UsSelfExclusion';
import appConfig from '../../../appConfig';

const isUs = appConfig.regions.isUS;

const SelfExclusion: React.FC = () => (
	<>
		<Helmet title="Self Exclusion" />
		{isUs ? <UsSelfExclusion /> : <PortalSelfExclusion />}
	</>
);

export default SelfExclusion;
